import {
  Avatar,
  Box,
  FormHelperText,
  TextField,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  ToggleButtonGroup,
  ToggleButton,
  Step,
  Stepper,
  StepLabel,
  StepContent,
  StepConnector,
  Grid,
  Typography,
  Button,
  Paper,
} from "@mui/material";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import React, { useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import cssVariables from "../../../../theme/cssVariables";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";

import { ReactComponent as PlusIcon } from "../../../../icons/plus-bigger.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as AlertRed } from "../../../../icons/alert-red.svg";
import Person from "../../../../icons/avatar.svg";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import IOSSwitch from "../../../../components/IOSSwitch";
import RedStarRequired from "../../../../components/RedStarRequired";

import WorkflowDialog from "../../../../components/adminConfigWorkflow/WorkflowDialog";
import MessageDialog from "../../../../components/MessageDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";

import { getWorkflow, getWorkflowTemplate, postCreateWorkflow, postWorkflowStep, putWorkflowStep, deleteWorkflowStep, putWorkflow, getWorkflowStep } from "../../../../actions/admin/workflow";

const useStyles = makeStyles({
  plusSvg: {
    "& > path": {
      fill: cssVariables.color.primary,
      stroke: "#fff",
    },
  },
  draggingListItem: {
    background: "rgb(235,235,235)",
  },
  flexPaper: {
    flex: 1,
    minWidth: 350,
    "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
    "border-radius": "10px !important        ",
  },
  tab: {
    fontSize: "16px !important",
    fontWeight: "300 !important",
    // color: "#A3A3A3 !important",
    "&.Mui-selected": {
      color: cssVariables.color.primary + " !important",
    },
  },
  root: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
  },
  tableHeader: {
    fontWeight: 500,
    fontSize: "14px!important",
    color: "#A0A0A0",
  },
  profileContainer: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    marginTop: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
})

const StyledPaper = (props) => {
  return (
    <Paper
      sx={{
        py: 3,
        px: 4,
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
      }}
      {...props}
    >
      {props.children}
    </Paper>
  );
};

const StyledTableCellGoal = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#FAFAFA",
    borderTop: "1px solid #E5E5E5!important",
    borderBottom: "1px solid #E5E5E5!important",
    borderLeft: "0!important",
    borderRight: "0!important",
  },
  [`&.${tableCellClasses.body}`]: {
    backgroundColor: "#FFF",
    fontSize: 14,
  },
  "&:nth-of-type(1)": {
    width: "5%",
  },
  "&:nth-of-type(2)": {
    width: "15%",
  },
  "&:nth-of-type(3)": {
    width: "25%",
  },
  "&:nth-of-type(4)": {
    width: "30%",
  },
  "&:nth-of-type(5)": {
    width: "5%",
  },
  "&:nth-of-type(6)": {
    width: "5%",
  },
  "&:nth-of-type(7)": {
    width: "10%",
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}))

const StyledTableGoal = (props) => {
  const classes = useStyles();
  const { t } = useTranslation()
  const { doEdit, doDelete, ...oProps } = props
  let dataList = oProps?.data ?? []

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }))

  useEffect(() => {
    // console.log(dataList)
  }, [dataList])

  return (
    <TableContainer {...oProps}>
      <Table sx={{ minWidth: 650 }} aria-label="data table">
        <TableHead>
          <StyledTableRow>
            <StyledTableCellGoal align="left">
              <Typography classes={{ root: classes.tableHeader }}>
                {t("adminWorkflow.label.seq")}
              </Typography>
            </StyledTableCellGoal>
            <StyledTableCellGoal align="left">
              <Typography classes={{ root: classes.tableHeader }}>
                {t("adminWorkflow.label.action")}
              </Typography>
            </StyledTableCellGoal>
            <StyledTableCellGoal align="left">
              <Typography classes={{ root: classes.tableHeader }}>
                {t("adminWorkflow.label.field")}
              </Typography>
            </StyledTableCellGoal>
            <StyledTableCellGoal align="left">
              <Typography classes={{ root: classes.tableHeader }}>
                {t("adminWorkflow.label.description")}
              </Typography>
            </StyledTableCellGoal>
            <StyledTableCellGoal align="center">
              <Typography classes={{ root: classes.tableHeader }}>
                {t("adminWorkflow.label.editable")}
              </Typography>
            </StyledTableCellGoal>
            <StyledTableCellGoal align="center">
              <Typography classes={{ root: classes.tableHeader }}>
                {t("adminWorkflow.label.email")}
              </Typography>
            </StyledTableCellGoal>
            <StyledTableCellGoal align="left">
              <Typography classes={{ root: classes.tableHeader }}>
                {t("adminWorkflow.label.action")}
              </Typography>
            </StyledTableCellGoal>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {dataList.map((list, index) => {
            return (
              <StyledTableRow key={`step-${index}`}>
                <StyledTableCellGoal align="left">
                  <Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
                    {list?.step || ""}
                  </Typography>
                </StyledTableCellGoal>
                <StyledTableCellGoal align="left">
                  <Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
                    {list?.action?.label || ""}
                  </Typography>
                </StyledTableCellGoal>
                <StyledTableCellGoal align="left">
                  <Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
                    {list?.fields?.length > 0 ? list?.fields[0]?.label : ""}
                  </Typography>
                  {
                    (list?.fields?.length > 0 && list?.fields[0]?.value) &&
                    <Typography sx={{ fontSize: "14px", fontWeight: 400 }} color="#D8D8D8">
                      {list?.fields[0]?.value?.name || ""}
                    </Typography>
                  }
                </StyledTableCellGoal>
                <StyledTableCellGoal align="left">
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "fit-content",
                      minHeight: "50px"
                    }}
                  >
                    <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                      {list?.description?.en || ""}
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
                      {list?.description?.th || ""}
                    </Typography>
                  </Box>
                </StyledTableCellGoal>
                <StyledTableCellGoal align="center">
                  {(list?.step !== 1 && list?.options?.edit) ? <CustomCheckbox disabled defaultChecked /> : <></>}
                </StyledTableCellGoal>
                <StyledTableCellGoal align="center">
                  {list?.is_send_mail ? <CustomCheckbox disabled defaultChecked /> : <></>}
                </StyledTableCellGoal>
                <StyledTableCellGoal align="left">
                  <Box sx={{ display: "flex", flexDirection: "space-between" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <BootstrapTooltip
                        title={t("label.edit")}
                        placement="top"
                      >
                        <EditIcon style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => doEdit(list)} />
                      </BootstrapTooltip>
                    </Box>
                    {!list?.options?.disabled && list.step !== "1" && list.step > 1 ?
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <BootstrapTooltip
                          title={t("label.delete")}
                          placement="top"
                        >
                          <DeleteIcon style={{ cursor: "pointer" }} onClick={() => doDelete(list)} />
                        </BootstrapTooltip>
                      </Box>
                      : <></>
                    }
                  </Box>
                </StyledTableCellGoal>
              </StyledTableRow>
            )
          })
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const CustomStepContent = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  let step = props.data;
  let lang = props.lang;

  const removeParentheses = (value) => {
    let test = value.replace(/\([^()]*\)/g, '')
    return test
  }

  return (
    <StepContent>
      <Box sx={{ display: "flex" }}>
        <Avatar
          src={Person}
          sx={{
            width: 40,
            height: 40,
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexFlow: "column",
            marginLeft: "10px",
          }}
        >
          <Typography
            fontWeight={500}
            fontSize="14px"
            color="#939393"
          >
            {step?.fields.length > 0 ? step?.fields[0]?.value?.name ? removeParentheses(step?.fields[0]?.value?.name) : step?.fields[0]?.label : "-"}
          </Typography>
          <Typography
            fontWeight={400}
            fontSize="12px"
            color="#A0A0A0"
          >
            {lang === "EN" ? `Date: -` : `วันที่: -`}
          </Typography>
          <Box component="div" sx={{ width: "130px", height: "30px", border: "1px solid #DADADA", color: "#DADADA", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "center", mt: "10px" }}>
            <Typography
              fontSize="14px"
              fontWeight={500}
              color="#DADADA"
            >
              {lang === "EN" ? "Not Started" : "ยังไม่เริ่ม"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </StepContent>
  )
}

const ErrorHelper = () => {
  const { t } = useTranslation()
  return (
    <Grid container mt={0}>
      <Grid item xs={12} display="flex" justifyContent="start" alignItems="center">
        <AlertRed />
        <FormHelperText
          error={true}
          sx={{ ml: 1 }}
        >
          {t("label.pleaseFillOutThisField")}
        </FormHelperText>
      </Grid>
    </Grid>)
}

const GoalWorkflow = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { state } = useLocation()
  const { id, mode } = props

  const [workflowId, setWorkflowId] = React.useState("")
  const [workflowData, setWorkflowData] = React.useState("")
  const [stepList, setStepList] = React.useState([])
  const [isStepListEmptyDialogOpen, setIsStepListEmptyDialogOpen] = React.useState(false)

  const goToAdmin = (route, data) => {
    if (data) {
      navigate("/admin" + route, { replace: false, state: data });
    } else {
      navigate("/admin" + route, { replace: false });
    }
  }

  // formik validation
  const validationSchema = yup.object({
    code: yup.string().min(1).required(),
    type: yup.string().min(1).required(),
    name: yup.string().min(1).required(),
    status: yup.boolean().required(),
    description: yup.string().min(1).required(),
  });
  const formik = useFormik({
    initialValues: {
      code: "",
      type: "",
      name: "",
      status: true,
      description: "",
      type: ""
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: () => {
      console.log("submit")
      if (stepList.length > 0) {
        if (mode === "edit") {
          handleSubmitUpdate()
        } else {
          handleSubmitCreate()
        }
      } else {
        setIsStepListEmptyDialogOpen(true)
      }
      // do create or update here
    },
  })

  // preview lang & data
  const [previewLang, setPreviewLang] = React.useState("EN");
  const handleChangePreviewLang = (e, val) => {
    setPreviewLang(val);
  }
  const [isConfirmDiscardDialogOpen, setIsconfirmDiscardDialogOpen] = React.useState(false)
  const handleConfirmDiscard = () => {
    setIsconfirmDiscardDialogOpen(false, goToAdmin("/workflow"))
  }

  // workflow dialog
  const [isWorkflowDialogOpen, setIsGoalWorkflowDialogOpen] = React.useState(false)
  const [countStep, setCountStep] = React.useState(0)
  const handleAddStep = () => {
    setTypeWorkflowTemplate("add")
    setIsGoalWorkflowDialogOpen(true)
  }
  const handleCloseWorkflowDialog = () => {
    setIsGoalWorkflowDialogOpen(false)
  }

  const [templateId, setTemplateId] = React.useState("")
  const [workflowTemplateDate, setWorkflowTemplateData] = React.useState([])
  const [isUsed, setIsUsed] = React.useState(false)
  const [isOnlyStep, setIsOnlyStep] = React.useState(false)

  const handleName = (e) => {
    formik.setFieldTouched('name', true)
    formik.setFieldValue("name", e.target.value)
  }
  const handleDescription = (e) => {
    formik.setFieldTouched('description', true)
    formik.setFieldValue("description", e.target.value)
  }

  const fetchTemplateData = () => {
    dispatch(getWorkflowTemplate("goal")).then((resp) => {
      if (resp?.fields && resp?.actions) {
        let workflowTemplateData = {
          actions: resp.actions,
          fields: resp.fields
        }
        setWorkflowTemplateData(workflowTemplateData)
      }
      if (mode !== "edit") {
        if (resp?.steps && resp?.steps?.length > 0) {
          // set default status
          let steps = [...resp.steps].map(item => {
            return {
              ...item,
              status: "active"
            }
          })
          setStepList(steps)
          if (resp.steps[0]?.template_id) setTemplateId(resp.steps[0].template_id)
        }
      }
    })
  }

  const fetchWorkflowData = (step = false) => {
    if (id && id !== "") {
      setIsOnlyStep(step)
      dispatch(getWorkflow(id)).then(resp => {
        let workflow = resp?.workflow ?? null
        if (workflow) {
          setWorkflowData(workflow)
        }
      })
    }
  }

  const getDescription = (data) => {
    if (previewLang === "EN") {
      if (data.en && data.en !== "") {
        return data.en
      } else {
        return data.th
      }
    } else {
      if (data.th && data.th !== "") {
        return data.th
      } else {
        return data.en
      }
    }
  }

  const [editStepData, setEditStepData] = React.useState({})
  const [typeWorkflowTemplate, setTypeWorkflowTemplate] = React.useState({})

  const handleEditStep = (step) => {
    let tmpStep = { ...step }
    if (mode === "edit") {
      dispatch(getWorkflowStep(step.id)).then(resp => {
        if (resp?.workflow_step?.id) {
          tmpStep = {
            ...tmpStep,
            stepAssignId: resp?.workflow_step?.id
          }
        }
        setEditStepData(tmpStep, setIsGoalWorkflowDialogOpen(true))
        setTypeWorkflowTemplate("edit")
      })
    }
    setEditStepData(tmpStep, setIsGoalWorkflowDialogOpen(true))
    setTypeWorkflowTemplate("edit")
  }

  const handleDeleteStep = (step) => {
    if (mode !== "edit") {
      let tmpList = [...stepList].filter(list => list.step !== step.step)
      setStepList(tmpList)
    } else if (mode === "edit") {
      dispatch(deleteWorkflowStep(step.id)).then(() => fetchWorkflowData(true))
    }
  }

  const handleSubmitDialog = (data) => {
    let tmpStepList = [...stepList]
    let findActions = searchActions(data.action)
    let findFields = searchFields(data.field)
    if (findFields?.length > 0) {
      if (data?.value) {
        findFields[0] = {
          ...findFields[0],
          value: {
            code: data.value.code,
            id: data.value.value,
            name: data.value.oName
          },
        }
      }
    }
    if (typeWorkflowTemplate === "edit") {
      if (mode !== "edit") {
        let findList = tmpStepList.find(item => item.step === data.step)
        let newList = null
        if (data.step !== 1) {
          newList = {
            ...findList,
            actions: findActions,
            fields: findFields,
            description: {
              en: data?.descriptionEN || "",
              th: data?.descriptionTH || ""
            },
            is_send_mail: data?.emailNotice,
            options: {
              ...findList.options,
              edit: data?.editable
            }
          }
        } else {
          newList = {
            ...findList,
            fields: findFields,
            description: {
              en: data?.descriptionEN || "",
              th: data?.descriptionTH || ""
            },
            is_send_mail: data?.emailNotice,
            options: {
              ...findList.options,
              edit: data?.editable
            }
          }
        }
        tmpStepList = tmpStepList.map(old => (old.step === newList.step) ? newList : old)
        setStepList(tmpStepList, handleCloseWorkflowDialog())
      } else if (mode === "edit") {
        let newList = {
          step: data?.step,
          action: findActions?.code || "",
          field: findFields.length > 0 ? findFields[0].id : "",
          value: data?.value?.value || "",
          description_th: data?.descriptionTH || "",
          description_en: data?.descriptionEN || "",
          tooltip_th: data?.descriptionTH || "",
          tooltip_en: data?.descriptionEN || "",
          is_send_mail: data?.emailNotice,
          is_edit: data?.editable,
        }
        dispatch(putWorkflowStep(data?.stepAssignId, newList)).then(resp => {
          handleCloseWorkflowDialog()
          fetchWorkflowData(true)
        })
      }
    } else if (typeWorkflowTemplate === "add") {
      if (mode !== "edit") {
        if (findFields?.length > 0) {
          if (data?.value) {
            findFields[0] = {
              ...findFields[0],
              value: {
                code: data.value.code,
                id: data.value.value,
                name: data.value.oName
              },
            }
          }
        }
        let newList = {
          step: data?.step,
          action: findActions,
          fields: findFields,
          description: {
            en: data?.descriptionEN || "",
            th: data?.descriptionTH || ""
          },
          options: {
            disabled: false,
            edit: data?.editable
          },
          tooltip: {
            en: data?.descriptionEN || "",
            th: data?.descriptionTH || ""
          },
          is_send_mail: data?.emailNotice,
        }
        tmpStepList = [...stepList]
        tmpStepList.push(newList)
        setStepList(tmpStepList, handleCloseWorkflowDialog())
      } else if (mode === "edit") {
        let newList = {
          workflow_id: workflowId,
          step: data?.step,
          action: findActions?.code || "",
          field: findFields.length > 0 ? findFields[0].id : "",
          value: data?.value?.value || "",
          description_th: data?.descriptionTH || "",
          description_en: data?.descriptionEN || "",
          tooltip_th: data?.descriptionTH || "",
          tooltip_en: data?.descriptionEN || "",
          is_send_mail: data?.emailNotice,
          is_edit: data?.editable,
        }
        dispatch(postWorkflowStep(newList)).then(resp => {
          handleCloseWorkflowDialog()
          fetchWorkflowData(true)
        })
      }
    }
  }

  const handleSubmitForm = () => {
    formik.submitForm()
    dispatch({
      type: "SCROLL_TO_ERROR",
      payload: true,
    })
  }

  const searchActions = (search) => {
    let result = [...workflowTemplateDate.actions].find(workflow => workflow.code === search)
    return result
  }

  const searchFields = (search) => {
    let result = [...workflowTemplateDate.fields].filter(workflow => workflow.code === search)
    return result
  }

  const formatStepList = (data) => {
    let resultArray = []
    let tmpObj = {
      // workflow_id: "",
      // id: "",
      // tooltip_th: "",
      // tooltip_en: "",
      // is_hide_score_self: false,
      // is_reject: false,
      // is_edit: false,
      // value: ""
    }
    if (data.length > 0) {
      data.sort((a, b) => a.step - b.step).forEach(item => {
        tmpObj = {
          ...tmpObj,
          id: item.id,
          step: item.step,
          action: item.action.code,
          field: item?.fields?.length > 0 ? item.fields[0].id : "",
          description_th: item.description.th,
          description_en: item.description.en,
          status: "active",
          is_send_mail: item.is_send_mail,
          template_id: templateId
        }
        if (item.action?.code !== "submit") {
          if (item?.fields?.length > 0 && item?.fields?.[0]?.value && item?.fields?.[0]?.value?.id) {
            tmpObj = {
              ...tmpObj,
              value: item?.fields?.[0]?.value?.id
            }
          }
          if (item?.options?.is_edit || item?.options?.edit) {
            tmpObj = {
              ...tmpObj,
              is_edit: item?.options?.is_edit || item?.options?.edit
            }
          }
        }
        resultArray.push(tmpObj)
      })
    }
    return resultArray
  }

  const [isSuccessCreateDialogOpen, setIsSuccessCreateDialogOpen] = React.useState(false)

  const handleSuccessCreateDialog = () => {
    setIsSuccessCreateDialogOpen(false, goToAdmin("/workflow"))
  }

  const handleSubmitCreate = () => {
    let formattedStepList = formatStepList(stepList)
    let data = {
      code: formik.values.code,
      type: formik.values.type,
      name: formik.values.name,
      status: formik.values.status ? "active" : "inactive",
      description: formik.values.description,
      type: formik.values.type.toLowerCase() === "evaluation" ? "evaluate" : formik.values.type,
      steps: formattedStepList,
    }
    dispatch(postCreateWorkflow(data)).then(resp => {
      setIsSuccessCreateDialogOpen(true)
    })
  }

  const [isSuccessUpdateDialogOpen, setIsSuccessUpdateDialogOpen] = React.useState(false)
  const handleSuccessUpdateDialog = () => {
    setIsSuccessUpdateDialogOpen(false, goToAdmin("/workflow"))
  }
  const handleSubmitUpdate = () => {
    let formattedStepList = formatStepList(stepList)
    let data = {
      code: formik.values.code,
      type: formik.values.type,
      name: formik.values.name,
      status: formik.values.status ? "active" : "inactive",
      description: formik.values.description,
      type: formik.values.type.toLowerCase() === "evaluation" ? "evaluate" : formik.values.type,
      steps: formattedStepList,
    }
    dispatch(putWorkflow(id, data)).then(() => {
      setIsSuccessUpdateDialogOpen(true)
    })
  }

  const setDataForEdit = (data) => {
    if (!isOnlyStep) {
      formik.setFieldValue("code", data?.code ?? "")
      formik.setFieldValue("type", data?.type ?? "")
      formik.setFieldValue("name", data?.name ?? "")
      formik.setFieldValue("status", data?.status === "active" ? true : false)
      formik.setFieldValue("description", data?.description ?? "")
    }
    setIsUsed(data?.is_used ?? false)
    setWorkflowId(data?.id || "")
    setStepList(data?.steps)
  }

  const mounted = useRef(false)
  // useEffect
  useEffect(() => {
    fetchTemplateData()
    fetchWorkflowData()
    mounted.current = true
    return () => {
      mounted.current = false;
    }
  }, [])

  useEffect(() => {
    if (mode === "edit" && workflowData) {
      setDataForEdit(workflowData)
    }
  }, [mode, workflowData])

  useEffect(() => {
    if (mode !== "edit") {
      formik.setFieldValue("code", state?.code ?? "")
      formik.setFieldValue("type", state?.type ?? "")
    }
  }, [state])


  useEffect(() => {
    setCountStep(stepList.length)
  }, [stepList])

  // end useEffect

  return (
    <Grid container mt={3}>
      <Grid item xs={12}>
        <Grid container spacing={4}>
          <Grid item xs={9}>
            <StyledPaper>
              <Grid container mb={1} spacing={4}>
                <Grid item xs={6} display="flex" alignItems="center">
                  <Typography color="#404349" fontSize={18} fontWeight="500">
                    {t("adminWorkflow.form.code")}
                  </Typography>
                  <RedStarRequired />
                </Grid>
                <Grid item xs={6} display="flex" alignItems="center">
                  <Typography color="#404349" fontSize={18} fontWeight="500">
                    {t("adminWorkflow.form.type")}
                  </Typography>
                  <RedStarRequired />
                </Grid>
              </Grid>
              <Grid container mb={2} spacing={4}>
                <Grid
                  item
                  xs={6}
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  sx={{
                    p: 0,
                    ".MuiInputBase-input": {
                      backgroundColor: "#FAFAFA",
                      "-webkit-text-fill-color": "#000 !important",
                      borderRadius: "4px",
                      p: "4px 10px",
                      height: "35px",
                    },
                    fieldset: { borderColor: "#FFFFFF !important" },
                  }}
                >
                  <TextField
                    error={Boolean(formik.touched.code && formik.errors.code)}
                    sx={{ mt: 0 }}
                    fullWidth
                    margin="normal"
                    name="code"
                    disabled
                    type="text"
                    value={formik.values.code}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {Boolean(formik.touched.code && formik.errors.code) && <ErrorHelper />}
                </Grid>
                <Grid
                  item
                  xs={6}
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  sx={{
                    p: 0,
                    ".MuiInputBase-input": {
                      backgroundColor: "#FAFAFA",
                      "-webkit-text-fill-color": "#000 !important",
                      borderRadius: "4px",
                      p: "4px 10px",
                      height: "35px",
                      textTransform: "capitalize"
                    },
                    fieldset: { borderColor: "#FFFFFF !important" },
                  }}
                >
                  <TextField
                    error={Boolean(formik.touched.type && formik.errors.type)}
                    sx={{ mt: 0 }}
                    fullWidth
                    margin="normal"
                    name="type"
                    disabled
                    type="text"
                    value={formik.values.type}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {Boolean(formik.touched.type && formik.errors.type) && <ErrorHelper />}
                </Grid>
              </Grid>
              <Grid container mb={1} spacing={4}>
                <Grid item xs={6} display="flex" alignItems="center">
                  <Typography color="#404349" fontSize={18} fontWeight="500">
                    {t("adminWorkflow.form.name")}
                  </Typography>
                  <RedStarRequired />
                </Grid>
                <Grid item xs={6} display="flex" alignItems="center">
                  <Typography color="#404349" fontSize={18} fontWeight="500">
                    {t("adminWorkflow.form.status")}
                  </Typography>
                  <RedStarRequired />
                </Grid>
              </Grid>
              <Grid container mb={2} spacing={4}>
                <Grid
                  item
                  xs={6}
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  sx={{
                    p: 0,
                    ".MuiInputBase-input": {
                      borderRadius: "4px",
                      p: "4px 10px",
                      height: "35px",
                    },
                  }}
                >
                  <TextField
                    sx={{ my: 0 }}
                    error={Boolean(formik.touched.name && formik.errors.name)}
                    fullWidth
                    margin="normal"
                    placeholder={t("adminWorkflow.form.fillTheName")}
                    name="name"
                    type="text"
                    value={formik.values.name}
                    onChange={handleName}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {Boolean(formik.touched.name && formik.errors.name) && <ErrorHelper />}
                </Grid>
                <Grid
                  item
                  xs={6}
                  display="flex"
                  alignItems="center"
                  sx={{
                    p: 0,
                    ".MuiInputBase-input": {
                      borderRadius: "4px",
                      p: "4px 10px",
                      height: "35px",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
                      backgroundColor: "#D8D8D8!important"
                    }
                  }}
                >
                  <IOSSwitch checked={formik.values.status} disabled={isUsed} onChange={() => formik.setFieldValue("status", !formik.values.status)} />
                  <Typography color="#404349" fontSize={18} fontWeight="500">
                    {formik.values.status ? t("label.active") : t("label.inactive")}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container mb={1} spacing={4}>
                <Grid item xs={12} display="flex">
                  <Typography color="#404349" fontSize={18} fontWeight="500">
                    {t("adminWorkflow.form.description")}
                  </Typography>
                  <RedStarRequired />
                </Grid>
              </Grid>
              <Grid container mb={2} spacing={4}>
                <Grid
                  item
                  xs={12}
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  sx={{
                    p: 0,
                    ".MuiInputBase-input": {
                      borderRadius: "4px",
                      p: "4px 10px",
                      height: "35px",
                    },
                  }}
                >
                  <TextField
                    error={Boolean(formik.touched.description && formik.errors.description)}
                    sx={{ my: 0 }}
                    fullWidth
                    margin="normal"
                    placeholder={t("adminWorkflow.form.fillTheDescription")}
                    name="description"
                    type="text"
                    value={formik.values.description}
                    onChange={handleDescription}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {Boolean(formik.touched.description && formik.errors.description) && <ErrorHelper />}
                </Grid>
              </Grid>
              <Grid container mb={1} spacing={4}>
                <Grid item display="flex" alignItems="center">
                  <Typography color="#404349" fontSize={18} fontWeight="500">
                    {t("adminWorkflow.form.workflowTemplate")}
                  </Typography>
                  <RedStarRequired />
                </Grid>
                <Grid item ml="auto" display="flex" alignItems="center">
                  <Button color="primary" variant="text" onClick={() => handleAddStep()}>
                    <PlusIcon className={classes.plusSvg} />
                    <Typography
                      fontSize="18px"
                      fontWeight="500"
                      sx={{ textTransform: "none", ml: 1 }}
                    >
                      {t("adminWorkflow.form.add")}
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
              <Grid container mb="30px">
                <Grid item display="flex" alignItems="center" xs={12}>
                  <StyledTableGoal sx={{ width: "100%" }} data={stepList} doEdit={handleEditStep} doDelete={handleDeleteStep} />
                </Grid>
              </Grid>
              <Grid container mb={1}>
                <Grid
                  item
                  display="flex"
                  alignItems="center"
                  xs="auto"
                  ml="auto"
                >
                  <Button
                    size="small"
                    aria-controls="cancle"
                    aria-haspopup="true"
                    color="black"
                    variant="outlined"
                    sx={{
                      width: "114px",
                      height: "45px",
                      p: "0",
                      textTransform: "none",
                    }}
                    onClick={() => setIsconfirmDiscardDialogOpen(true)}
                  >
                    <Typography fontWeight="500" fontSize={18} color="#6B6B6B">
                      {t("label.cancel")}
                    </Typography>
                  </Button>
                  <Button
                    size="small"
                    aria-controls="create"
                    aria-haspopup="true"
                    color="primary"
                    variant="contained"
                    disabled={!mounted.current}
                    sx={{
                      width: "114px",
                      height: "45px",
                      p: "0",
                      textTransform: "none",
                      ml: "35px",
                    }}
                    onClick={() => handleSubmitForm()}
                  >
                    <Typography fontWeight="500" fontSize={18}>
                      {mode === "edit" ? t("label.save") : t("label.create")}
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </StyledPaper>
          </Grid>
          <Grid item xs={3}>
            <StyledPaper>
              <Grid container mb={1} spacing={4}>
                <Grid
                  item
                  xs={12}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography color="#404349" fontSize={24} fontWeight="600">
                    {t("adminWorkflow.label.preview")}
                  </Typography>
                  <ToggleButtonGroup
                    color="primary"
                    value={previewLang}
                    exclusive
                    onChange={handleChangePreviewLang}
                    aria-label="Platform"
                    size="small"
                    sx={{
                      "& .MuiToggleButton-root": {
                        width: "75px",
                        height: "30px",
                        fontWeight: 400,
                        fontSize: 14,
                        textTransform: "none",
                      },
                      "& .Mui-selected": { borderColor: "#5DA196" },
                    }}
                  >
                    <ToggleButton value="EN">Eng</ToggleButton>
                    <ToggleButton value="TH">Thai</ToggleButton>
                  </ToggleButtonGroup>
                </Grid>
              </Grid>
              <Grid container>
                <Box sx={{ maxWidth: 400 }} id="steppers">
                  <Stepper
                    orientation="vertical"
                    sx={{
                      flexDirection: "column-reverse",
                      overflow: "auto",
                      maxHeight: "inherit",
                      marginTop: "10px",
                      "& .MuiSvgIcon-root": {
                        color: "#D8D8D8!important"
                      },
                      "& .MuiStep-root:not(:first-of-type) > .MuiStepContent-root": {
                        borderLeft: "1px dashed #BBBEBE", borderTop: 0, borderBottom: 0, borderRight: 0
                      },
                      "& .MuiStep-root:first-of-type > .MuiStepContent-root": {
                        borderLeft: 0, borderTop: 0, borderBottom: 0, borderRight: 0
                      },
                      "& .MuiStepConnector-line": {
                        borderLeftStyle: "dashed!important"
                      }
                    }}
                    connector={<StepConnector />}
                  >
                    {
                      stepList.map((list, index) => {
                        return (
                          <Step
                            active={true}
                            key={`steplist-${index}`}
                          >
                            <StepLabel>
                              <Typography fontWeight={600} fontSize="18px">{getDescription(list?.description)}</Typography>
                            </StepLabel>
                            <CustomStepContent
                              data={list}
                              lang={previewLang}
                            />
                          </Step>
                        )
                      })
                    }
                  </Stepper>
                </Box>
              </Grid>
            </StyledPaper>
          </Grid>
        </Grid>
      </Grid>
      <WorkflowDialog open={isWorkflowDialogOpen} onClose={handleCloseWorkflowDialog} editData={editStepData} addData={{ countStep: countStep, is_send_mail: true }} workflowTemplateData={workflowTemplateDate} type={typeWorkflowTemplate} doSubmit={handleSubmitDialog} />
      {/* success create dialog */}
      <MessageDialog
        open={isSuccessCreateDialogOpen}
        setValue={handleSuccessCreateDialog}
        title={t('adminWorkflow.dialog.successCreateTitle')}
        text={t('adminWorkflow.dialog.successCreateDesc')}
      />
      {/* success edit dialog */}
      <MessageDialog
        open={isSuccessUpdateDialogOpen}
        setValue={handleSuccessUpdateDialog}
        title={t('adminWorkflow.dialog.successUpdateTitle')}
        text={t('adminWorkflow.dialog.successUpdateDesc')}
      />
      {/* step empty */}
      <MessageDialog
        open={isStepListEmptyDialogOpen}
        setValue={setIsStepListEmptyDialogOpen}
        type="fail"
        title={t('adminWorkflow.dialog.errorStepListEmptyTitle')}
        text={t('adminWorkflow.dialog.errorStepListEmptyDesc')}
      />
      {/* confirm discard */}
      <ConfirmDialog
        open={isConfirmDiscardDialogOpen}
        doConfirm={handleConfirmDiscard}
        warning={true}
        setValue={setIsconfirmDiscardDialogOpen}
        title={t("label.confirmationOfDiscard")}
        text={t("label.youSureDiscardChange")}
      />
    </Grid>
  )
}

export default GoalWorkflow